export default "__VITE_ASSET__BRG3PNOD__"